/**
 * @fileoverview Suggested habit categories.
 * @module lib/domain/categories
 */

/** Suggested categories offered in the habit form. */
export const PREDEFINED_CATEGORIES = [
	"Sport",
	"Santé",
	"Travail",
	"Bien-être",
	"Autre",
] as const
